var map = {
	"./da-DK.json": "VuCH",
	"./dan.json": "zKQ8",
	"./de-DE.json": "V40Y",
	"./dut.json": "qKMH",
	"./en-US.json": "xPBe",
	"./es-419.json": "xw69",
	"./es-ES.json": "sngT",
	"./fi-FI.json": "V0tG",
	"./fin.json": "W9kh",
	"./fr-FR.json": "Y+yF",
	"./fre.json": "QyXP",
	"./ger.json": "8qnX",
	"./id-ID.json": "E/3g",
	"./ind.json": "+UFt",
	"./it-IT.json": "KbHO",
	"./ita.json": "XqKw",
	"./ja-JP.json": "6qQk",
	"./jpn.json": "pxQ5",
	"./ko-KR.json": "GMB3",
	"./kor.json": "dJ0y",
	"./nl-NL.json": "42kG",
	"./por-BR.json": "FshU",
	"./pt-BR.json": "oCDu",
	"./ro-RO.json": "43cW",
	"./ru-RU.json": "gnbZ",
	"./rum.json": "+b5Q",
	"./rus.json": "b2tF",
	"./spa-ES.json": "lCaJ",
	"./tr-TR.json": "LY4o",
	"./tur.json": "8NiF",
	"./vi-VN.json": "RlAn",
	"./vie.json": "Rhrx",
	"./zh-CN.json": "JH5D",
	"./zho-CN.json": "Wq0T"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eS4C";